import { Feature, configureObj } from "../../common/@types";
import { getModuleRoutes } from "@brightinsight/bi-web-dms-modules";
import { RouteConstants } from "./constants/RouteConstants";

// Define the Patients module configuration function
const Onboarding = (applnFeature: Feature) => {
  // Retrieve module routes and menu items list based on the application feature and route constants
  const { moduleRoutes, menuItemsList }: configureObj = getModuleRoutes(
    applnFeature,
    RouteConstants
  );

  // Create the module configuration object
  const moduleConfig = {
    configureObj: {
      routes: moduleRoutes,
      menuOptions: menuItemsList,
    },
  };

  // Return the module configuration
  return moduleConfig;
};

// Export the Patients module
export { Onboarding };
